import { render } from "./Home.vue?vue&type=template&id=3c6aeeda&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=3c6aeeda&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6aeeda"]])

export default __exports__